import { z } from 'zod';

import {
  DocumentSchema,
  GetDocumentsQuerySchema,
  GetDocumentsResponseSchema,
  GetDocumentSignedUrlResponseSchema,
  UpdateDocumentRequestSchema,
  UploadDocumentRequestSchema,
} from './media';
import { buildQueryString } from '../../utils/querystring';
import { makeEndpoint } from '../common';

export const CreateSignedUrlsEndpoint = makeEndpoint({
  method: 'POST',
  url: () => '/v1/media/signed-urls',
  requestSchema: z.object({
    fileNames: z.array(z.string()),
  }),
  responseSchema: z.array(
    z.object({
      mediaId: z.string().uuid(),
      signedUrl: z.string(),
    }),
  ),
});

export const ProcessVideosEndpoint = makeEndpoint({
  method: 'POST',
  url: () => '/v1/media/videos/process',
  requestSchema: z.object({
    mediaIds: z.array(z.string().uuid()),
  }),
  responseSchema: z.void(),
});

export const UploadDocumentEndpoint = makeEndpoint({
  method: 'POST',
  url: ({ brandId }: { brandId: string }) => `v1/brands/${brandId}/documents`,
  responseSchema: DocumentSchema,
  requestSchema: UploadDocumentRequestSchema,
});

export const GetDocumentsEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, query }: { brandId: string; query: z.input<typeof GetDocumentsQuerySchema> }) =>
    `v1/brands/${brandId}/documents?${buildQueryString(query)}`,
  responseSchema: GetDocumentsResponseSchema,
  requestSchema: z.void(),
  querySchema: GetDocumentsQuerySchema,
});

export const GetDocumentSignedUrlEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ brandId, documentId }: { brandId: string; documentId: string }) =>
    `v1/brands/${brandId}/documents/${documentId}/signed-url`,
  responseSchema: GetDocumentSignedUrlResponseSchema,
  requestSchema: z.void(),
});

export const UpdateDocumentEndpoint = makeEndpoint({
  method: 'PUT',
  url: ({ brandId, documentId }: { brandId: string; documentId: string }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: DocumentSchema,
  requestSchema: UpdateDocumentRequestSchema,
});

export const DeleteDocumentEndpoint = makeEndpoint({
  method: 'DELETE',
  url: ({ brandId, documentId }: { brandId: string; documentId: string }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: z.void(),
  requestSchema: z.void(),
});
